<template>
  <div>
    <el-button
      v-if="flag"
      :size="size"
      icon="el-icon-s-operation"
      class="btnTwo"
      style="color: #1476c3; border-color: #1476c3; float: right"
      @click="menuClick()"
      >列表配置</el-button
    >

    <!-- 自定义菜单栏 -->
    <el-dialog
      :append-to-body="true"
      :visible.sync="dialogState.show1"
      :close-on-click-modal="false"
      :show-close="true"
      class="dialog"
      :title="'列表配置'"
      @close="dialogClose"
      width="1120px"
    >
      <div style="margin-bottom: 10px">
        <el-button
          style="float: left"
          icon="el-icon-refresh"
          @click="resetClick"
          size="mini"
          type="primary"
          >重置</el-button
        >
        <el-button
          size="mini"
          icon="el-icon-back"
          style="float: right"
          type="info"
          @click="dialogClose"
          >返回</el-button
        >
        <el-button
          size="mini"
          icon="el-icon-sort"
          style="float: right"
          type="primary"
          @click="sortGetList"
          >排序</el-button
        >
        <div style="clear: both"></div>
      </div>
      <el-table
        :data="titleList"
        border
        size="mini"
        :max-height="this.$root.tableHeight + 10"
        @sort-change="sortChange"
        :key="Math.random()"
        v-loading="dragSortShow"
        element-loading-text="拼命加载中"
      >
        <el-table-column width="50" label="序号" align="center">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="表头名称" align="center" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="字段类型" align="center" width="120">
          <template slot-scope="scope">
            <span>{{ typeGet(scope.row.value) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否显示" align="center" width="120">
          <template slot-scope="scope">
            <el-select
              size="mini"
              v-model="scope.row.isShow"
              @change="onEnd"
              placeholder="请选择"
            >
              <el-option
                v-for="item in isShowList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="是否固定" align="center" width="120">
          <template slot-scope="scope">
            <el-select
              size="mini"
              v-model="scope.row.fixedState"
              @change="onEnd"
              placeholder="请选择"
            >
              <el-option
                v-for="item in fixedStateList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="固定位置" align="center" width="150">
          <template slot-scope="scope">
            <el-select
              size="mini"
              v-model="scope.row.align"
              @change="onEnd"
              placeholder="请选择"
            >
              <el-option
                v-for="item in alignList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="宽度" align="center" width="120">
          <template slot-scope="scope">
            <el-input
              size="mini"
              @blur="onEnd"
              type="number"
              v-model="scope.row.width"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="权限人" align="center" width="150">
          <template slot-scope="scope">
            <div @click="userClick(scope.row)" style="width: 100%">
              {{ getUserName(scope.row.userList) }}
            </div>
          </template>
        </el-table-column>
        <!-- @input="(v) => (scope.row.sort = v.replace(/[^\d]/g, ''))" -->
        <el-table-column label="排序" align="center" width="120" sortable>
          <template slot-scope="scope">
            <el-input size="mini" type="number" v-model="scope.row.sort"></el-input>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
      :append-to-body="true"
      :visible.sync="dialogState.show2"
      :close-on-click-modal="false"
      :show-close="true"
      :title="'人员选择'"
      @close="dialogClose2"
    >
      <mySelectList
        :height="this.$root.tableHeight - 200"
        :list="userGetList(userList)"
        :listQuery="userListQuery"
        :titleList="userTitleList"
        :selectList="dialogUserList"
        :listQueryStatus="1"
        @getList="userGetData"
      ></mySelectList>
      <div style="margin-top: 20px; text-align: center">
        <el-button type="primary" @click="userClickOk">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { sortList } from '@/utils/myUtils';
import { SystemController } from '@/api';
import { getObjectFromSessionStorage } from '@/utils';
export default {
  props: {
    // table显示的标头集合
    titleList: {
      type: Array,
      required: false,
      default() {
        return [];
      }
    },
    flag: {
      type: Boolean,
      required: false,
      default: false
    },
    size: {
      type: String,
      default: 'small'
    }
  },
  data() {
    return {
      drag: false,
      dialogState: {
        show1: false,
        show2: false
      },
      userListQuery: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      userTitleList: [
        {
          id: 0,
          name: '员工编号', // 必传
          value: 'loginName' // 必传
        },
        {
          id: 0,
          name: '员工名称', // 必传
          value: 'showName' // 必传
        },
        {
          id: 0,
          name: '联系方式', // 必传
          value: 'mobile' // 必传
        }
      ],
      sort: 'ascending',
      // 是否显示
      isShowList: [
        { label: '不显示', value: false },
        { label: '显示', value: true }
      ],
      // 是否固定
      fixedStateList: [
        { label: '不固定', value: false },
        { label: '固定', value: true }
      ],
      // 固定位置
      alignList: [
        { label: '左对齐', value: 'left' },
        { label: '居中对齐', value: 'center' },
        { label: '右对齐', value: 'right' }
      ],
      //
      userList: [],
      rowData: {},
      dialogUserList: [],
      searchData: null,
      dragSortShow: false
    };
  },
  created() {},
  methods: {
    getList() {
      this.dragSortShow = true;
      try {
        let list = [];
        for (let i = 0; i < this.titleList.length; i++) {
          let item = this.titleList[i];
          if (!item.sort) {
            item.sort = null;
          }
          if (!item.align) {
            item.align = null;
          }
          list.push(item);
        }
        this.titleList = JSON.parse(JSON.stringify(list));
      } catch (error) {}
      this.dragSortShow = false;
    },
    userGetList(list) {
      let data = [];
      try {
        data = list.filter((item) => {
          return (
            !this.searchData ||
            item.showName.toLowerCase().includes(this.searchData.toLowerCase()) ||
            item.loginName.toLowerCase().includes(this.searchData.toLowerCase())
          );
        });
      } catch (error) {
        data = list;
      }
      return data;
    },
    userGetData(searchData) {
      this.searchData = searchData;
    },
    getUserName(list) {
      let data = '';
      if (list && list.length > 0) {
        list.forEach((item, index) => {
          if (index == list.length - 0) {
            data += item.showName;
          } else {
            data += item.showName + ',';
          }
        });
      } else {
        data = '全部';
      }
      return data;
    },
    userClick(row) {
      this.dialogState.show2 = true;
      this.rowData = row;
      this.dialogUserList = JSON.parse(JSON.stringify(row.userList)) || [];
    },
    userClickOk() {
      this.rowData.userList = this.dialogUserList;
      this.onEnd();
      this.dialogState.show2 = false;
    },
    // 排序
    sortGetList() {
      // sortList(this.titleList, "sort");
      this.titleList = this.titleList.sort((a, b) => {
        if (!a.sort && b.sort) {
          return 1;
          // 把空值放在最后
        } else if (a.sort && !b.sort) {
          return -1;
          // 把空值放在最后
        } else {
          return a.sort - b.sort;
          // 其他情况按照数字大小排序
        }
      });
      this.$emit('onEnd', this.titleList);
    },
    // 排序功能
    sortChange(data) {
      const { prop, order } = data;
      this.sort = order;
      this.sortGet();
    },
    sortGet() {
      if (this.sort === 'ascending') {
        this.titleList.sort(function (a, b) {
          return a.sort - b.sort;
        });
      } else {
        this.titleList.sort(function (a, b) {
          return b.sort - a.sort;
        });
      }
      this.$emit('onEnd', this.titleList);
    },
    typeGet(data) {
      if (data.indexOf('-ext') > 0) {
        return '自定义字段';
      } else {
        return '系统字段';
      }
    },
    async menuClick() {
      await this.getList();
      this.userList = await getObjectFromSessionStorage('userSelect');
      this.dialogState.show1 = await true;
    },
    dialogClose() {
      this.dialogState.show1 = false;
    },
    dialogClose2() {
      this.dialogUserList = [];
      this.dialogState.show2 = false;
    },
    // 开始拖拽事件
    onStart() {
      this.drag = true;
      this.$emit('onStart', this.titleList);
    },
    // 对齐方式
    alignItem(element, align) {
      this.drag = false;
      element.align = align;
      this.$emit('onEnd', this.titleList);
      document.body.click();
    },
    // 拖拽结束事件
    onEnd() {
      this.$forceUpdate();
      this.drag = false;
      this.$emit('onEnd', this.titleList);
    },
    // 复选框事件
    isShowClick() {
      this.$emit('isShowClick', this.titleList);
    },
    // 固定方向事件
    widthClick(data) {
      data.fixedState = !data.fixedState;
      this.$emit('widthClick', this.titleList);
    },
    // 重置
    resetClick() {
      this.$emit('resetClick', this.titleList);
    }
  }
};
</script>
<style lang="scss" scoped>
.imgOne {
  width: 14.36px;
  height: 14.36px;
  margin: 0 5px 0 5px;
  vertical-align: top;
}
.item {
  padding: 6px;
  background-color: #fdfdfd;
  cursor: pointer;
  -ms-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  display: flex;
}
.checkboxOne {
  position: relative;
  z-index: 1000;
}
.span {
  width: 500px;
  overflow: hidden; //超出的文本隐藏
  text-overflow: ellipsis; //用省略号显示
  white-space: nowrap; //不换行
}
.dragSort {
  max-height: 40vh;
  overflow-y: auto;
}

.align_item {
  cursor: pointer;
  padding: 2px;
}
.align_item:hover {
  background-color: #1476c3;
  color: #ffffff;
}
</style>
